var _document_querySelectorAll, _document_querySelectorAll1, _document_querySelectorAll2;
import IMask from 'imask';
window.phoneMask = [];
(_document_querySelectorAll = document.querySelectorAll('input[type="tel"]')) === null || _document_querySelectorAll === void 0 ? void 0 : _document_querySelectorAll.forEach(function($el, index) {
    window.phoneMask.push(IMask($el, {
        mask: '+{7} (000) 000-00-00',
        lazy: true
    }));
    // const mask = IMask($el, {
    // 	mask: '+{7} (000) 000-00-00',
    // 	lazy: true
    // })
    window.phoneMask[index].el.input.addEventListener('focus', function() {
        window.phoneMask[index].updateOptions({
            lazy: false
        });
    });
    // mask.el.input.addEventListener('focus', () => {
    // 	mask.updateOptions({
    // 		lazy: false
    // 	})
    // })
    window.phoneMask[index].el.input.addEventListener('blur', function() {
        if (!window.phoneMask[index].masked.isComplete) window.phoneMask[index].value = '';
        window.phoneMask[index].updateOptions({
            lazy: true
        });
    });
});
(_document_querySelectorAll1 = document.querySelectorAll('input[data-mask-number]')) === null || _document_querySelectorAll1 === void 0 ? void 0 : _document_querySelectorAll1.forEach(function($el) {
    return IMask($el, {
        mask: Number
    });
});
(_document_querySelectorAll2 = document.querySelectorAll('input[data-mask-date]')) === null || _document_querySelectorAll2 === void 0 ? void 0 : _document_querySelectorAll2.forEach(function($el) {
    var mask = IMask($el, {
        mask: Date,
        pattern: 'd{.}`m{.}`Y',
        lazy: false,
        overwrite: true,
        autofix: true,
        blocks: {
            d: {
                mask: IMask.MaskedRange,
                placeholderChar: 'д',
                from: 1,
                to: 31,
                maxLength: 2
            },
            m: {
                mask: IMask.MaskedRange,
                placeholderChar: 'м',
                from: 1,
                to: 12,
                maxLength: 2
            },
            Y: {
                mask: IMask.MaskedRange,
                placeholderChar: 'г',
                from: 1900,
                to: 2999,
                maxLength: 4
            }
        }
    });
    mask.el.input.addEventListener('blur', function() {
        if (!mask.masked.isComplete) mask.value = '';
    });
});
window.phoneReset = function() {
    window.phoneMask.forEach(function(item) {
        item.value = '';
    });
};
